const firstTimeModalHomeNewsletter = {
  'first-time-modal-home-title': 'Pandito Noticias',
  'first-time-modal-home-body': '¿Quieres mantenerte informado, saber en qué eventos estamos presentes y qué novedades hay en Pandito? ¡Entonces suscríbete a nuestro boletín informativo!',
  'first-time-modal-home-info': 'El boletín se enviará desde esta dirección de correo electronico: panditoicecream@gmail.com'
};

export default firstTimeModalHomeNewsletter;
